<template>
  <base-section
    id="submission-guidelines"
  >

    <base-section-heading title="Submission Guidelines">
    </base-section-heading>
    <v-container>
      <base-section-heading
      title="Paper submission Categories"
      >
      <div style="text-align: left !important">
        • <strong>Scientific Papers</strong> presenting novel and complete research work for inclusion in the <u>IEEE Formal Proceedings</u><br>
        &emsp;&emsp;- Deadline <s>December 16th, 2022</s> <strong> December 23rd, 2022</strong> (<strong><span style="color:red">Final Deadline</span></strong>)<br>
        &emsp;&emsp;- Up to 6 pages – double-column format<br>
        • <strong>Industrial papers</strong> presenting industry-relevant works for inclusion in the ETS23 <u>Informal Digest of Papers</u><br>
        &emsp;&emsp;- Deadline December 16th, 2022<br>
        &emsp;&emsp;- Up to 6 pages<br>
        • <strong>Late Industrial contributions</strong> for inclusion in the ETS23 <u>Informal Digest of Papers</u>:<br>
        &emsp;&emsp;- Deadline April 3rd, 2023<br>
        &emsp;&emsp;- Up to 2 pages<br>
      </div>
      </base-section-heading>
      <base-section-heading
      title="Review Process"
      >
      <div style="text-align: left !important">
        • Submitted <strong>Scientific Papers</strong> are reviewed by the <i>ETS23 Program Committee members and by the Companions</i><br>
        • The <i>Industrial Board members</i> review the submitted <strong>Industrial Papers</strong> and <strong>Late Industrial Papers</strong><br>
        • Submitted <strong>Scientific Papers with at least an author affiliated with the industry</strong> undergo both review processes<br>
      </div>
      </base-section-heading>
      <base-section-heading
      title="Acceptance Categories"
      >
      <div style="text-align: left !important">
        According to a rank and a discussion:<br>
        <strong> Scientific Papers </strong> can be accepted for: <br>
        • oral presentation, with the full paper (6 pages) included in the IEEE proceedings<br>
        • poster presentation, with a short paper version (4 pg) included in IEEE proc<br>
        <strong> Industrial papers </strong> can be accepted for: <br>
        • oral presentation or<br>
        • poster presentation,<br>
        • both with full paper (6 pages) included in the informal digest papers of ETS23<br>
        <strong> Late Industiral papers </strong> be accepted for: <br>
        • oral presentation or<br>
        • poster presentation,<br>
        • both with short paper (2 pages) included in the informal digest papers of ETS23<br>
        <br>
        <strong>Scientific papers</strong> with at least <strong>one industrial author</strong>, which are rejected as Scientific, can be accepted as Industrial.
      </div>
      </base-section-heading>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in submissionsfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < submissionsfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
      </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SubmissionGuidelines',

    data: () => ({
      isMobile: false,
      submissionsfooter: [
        {
          name: 'Submissions',
          url: 'submissions',
        },
        {
          name: 'Key Dates',
          url: 'key-dates',
        },
        {
          name: 'Topics',
          url: 'topics',
        },
        {
          name: 'Submit a Paper',
          url: 'cfp',
        },
        {
          name: 'Submission Guidelines',
          url: 'submission-guidelines',
        },
      ],
    }),
    mounted () {
      //  this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
